import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  RealtimeClientLoadUriAction,
  RealtimeClientStatusChangedAction,
} from '../../domains/realtimeClient/actions.types';

import { RealtimeClient, RealtimeClientStatus } from './types';

export type RealtimeClientAction = RealtimeClientStatusChangedAction | RealtimeClientLoadUriAction;

const initialState: RealtimeClient = {
  status: RealtimeClientStatus.Disconnected,
  uriLifecycle: {
    pending: false,
    fulfilled: undefined,
    rejected: undefined,
  },
};

const reducer: Reducer<RealtimeClient, RealtimeClientAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'REALTIME_CLIENT.STATUS_CHANGED': {
      return {
        ...state,
        status: action.payload.status,
      };
    }
    case 'REALTIME_CLIENT.LOAD_URI_PENDING':
      return {
        ...state,
        uriLifecycle: setPending(),
      };
    case 'REALTIME_CLIENT.LOAD_URI_FULFILLED':
      return {
        ...state,
        uriLifecycle: setFulfilled(action.payload.uri),
      };
    case 'REALTIME_CLIENT.LOAD_URI_REJECTED':
      return {
        ...state,
        uriLifecycle: setRejected(action.payload.error),
      };
    default:
      return state;
  }
};

export default reducer;
